export const ChatKeys = {
	all: ["chat"] as const,
	list: () => [...ChatKeys.all, "list"] as const,
	messages: (conversationId: number | null) =>
		[...ChatKeys.all, "messages", "v2", conversationId] as const,
	send: (conversationId: number | null) =>
		[...ChatKeys.all, "send", conversationId] as const,
	sendScope: (conversationId: number | null) =>
		`chat-send-${conversationId ?? "new"}`,
	attachmentImage: (attachmentId: number | undefined) =>
		[...ChatKeys.all, "attachment-image", attachmentId] as const,
};
